import Head from "next/head";
import { useParams } from "next/navigation";

interface SeoData {
  [key: string]: {
    title: string;
    description: string;
  };
}

const ExploreSEO: React.FC = () => {
  const query = useParams();
  const slug = query.slug;
  const seoData: SeoData = {
    tags: {
      title: "Explore Tags - DB News Cloud",
      description:
        "Explore the most popular tech trends, topics, and tags from the DB News Cloud community. A constantly updating list.",
    },
    "tags-following": {
      title: "Tags you follow - DB News Cloud",
      description: "Tags you follow - DB News Cloud",
    },
    articles: {
      title: "Explore Trending Articles - DB News Cloud",
      description:
        "A constantly updating list of best and popular tech blogs from the DB News Cloud dev community. Follow tech blogs you like.",
    },
    "articles-following": {
      title: "Explore Following Articles - DB News Cloud",
      description: "Articles you follow - DB News Cloud",
    },
  };

  const defaultSeoData: { title: string; description: string } = {
    title: "Explore Popular Tech Blogs and Topics - DB News Cloud",
    description:
      "A constantly updating list of best and popular tech blogs from the DB News Cloud dev community. Follow tech blogs you like.",
  };

  const pageTitle: string =
    !slug || !slug[0] || !seoData[slug[0]]
      ? "Explore Popular Tech Blogs and Topics - DB News Cloud"
      : seoData[slug[0]]?.title ||
      "Explore Popular Tech Blogs and Topics - DB News Cloud";

  return (
    <Head>
      <title>{pageTitle}</title>
      <meta
        name="description"
        content={
          seoData["/explore/articles"]?.description ||
          defaultSeoData.description
        }
      />

      {/* Open Graph tags for social media banner */}
      <meta property="og:title" content={pageTitle} />
      <meta
        property="og:description"
        content={
          seoData["/explore/articles"]?.description ||
          defaultSeoData.description
        }
      />
      <meta property="og:type" content="website" />
      <meta
        property="og:url"
        content={process.env.NEXT_PUBLIC_VERCEL_URL as string}
      />

      {/* Twitter card tags for Twitter banner */}
      <meta name="twitter:title" content={pageTitle} />
      <meta
        name="twitter:description"
        content={
          seoData["/explore/articles"]?.description ||
          defaultSeoData.description
        }
      />
      <meta name="twitter:card" content="summary_large_image" />

      {/* Other necessary tags */}
      <link
        rel="canonical"
        href={process.env.NEXT_PUBLIC_VERCEL_URL as string}
      />
      <meta name="viewport" content="width=device-width, initial-scale=1" />

      {/* Image tags */}
      <link rel="icon" href="/favicon.ico" />
      <link rel="apple-touch-icon" href="/favicon.ico" />
    </Head>
  );
};

export default ExploreSEO;
